import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { BREAKPOINTS } from 'configs/constants';
import { ROUTES } from 'configs/routes/constants';
import { isRenderInIframe } from 'helpers/Location';
import { inject, observer } from 'mobx-react';
import HeaderUserActions from 'modules/navigation/components/header/HeaderUserActions';
import SidebarContent from 'modules/navigation/components/sidebar/SidebarContent';
import PropTypes from 'prop-types';

import { openMenu, closeMenu } from './utils/eventsMenu';

import '@hotmart/cosmos/dist/menu';
import '@hotmart/cosmos/dist/menu-item';

import './menu.scss';

@inject((stores) => ({
  isMobile: stores.UiStore.isMobile,
  gridSize: stores.UiStore.gridSize,
  sidebarActive: stores.UiStore.sidebarActive,
  productName: stores.MembershipStore.name
}))
@observer
class Menu extends Component {
  static propTypes = {
    isMobile: PropTypes.bool.isRequired,
    gridSize: PropTypes.number.isRequired,
    sidebarActive: PropTypes.bool.isRequired,
    locationMenu: PropTypes.object.isRequired,
    productName: PropTypes.string.isRequired
  };

  componentDidMount() {
    const hotHeader = document?.querySelector('hot-header');
    const hotBrandElement = hotHeader?.shadowRoot?.querySelector(
      '.hot-application__brand'
    );

    if (hotBrandElement && isRenderInIframe()) {
      hotBrandElement.style.display = 'none';
    }
  }

  render() {
    const { locationMenu, productName, isMobile, gridSize, sidebarActive } =
      this.props;
    let biggerScreen = false;
    const { MD, LG } = BREAKPOINTS;

    const hasToOpenMenu = () => !(isMobile && biggerScreen) && gridSize >= MD;

    const showMenu = () => (isMobile ? closeMenu() : sidebarActive);

    if (hasToOpenMenu()) {
      biggerScreen = true;
      openMenu();
    }

    if (!isMobile && gridSize < LG) {
      biggerScreen = false;
    }

    if (isMobile) {
      biggerScreen = false;
    }

    const getClass = gridSize >= LG ? 'hot-application--pinned' : null;

    return (
      <hot-menu open={showMenu()} class={getClass} slot="menu">
        <div
          data-test="menu-product-name"
          slot="product-name"
          className="hot-menu-header"
        >
          <div data-test="product-name" className="hot-menu-header-title">
            {productName}
          </div>
        </div>

        <hot-header slot="header">
          <Link
            data-test="menu-logo-link"
            to={ROUTES.DEFAULT}
            slot="logo-link"
          />

          {!isRenderInIframe() && (
            <div data-test="menu-header-actions" slot="header-actions">
              <HeaderUserActions />
            </div>
          )}
        </hot-header>

        <SidebarContent location={locationMenu} />
      </hot-menu>
    );
  }
}

export default Menu;
